import React from "react";

import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import {
  DeleteIcon,
  TransferIcon,
} from "../../../../components/common/iconography";

const useStyles = makeStyles((theme) => ({
  icon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

export const CarrierUserCreateHelp = () => (
  <>
    <Typography variant="subtitle1">
      Creating a new Carrier sends out an email invitation to specified email
      address, asking the new user to complete signup process. The new User will
      not have access until they complete registration. They will need access to
      their email to complete the process.
    </Typography>
    <ul>
      <li>
        <Typography>
          <strong>Account: </strong> Select the Account to which the user should
          have access to. They will have access only to the selected Account's
          data. Account cannot be changed once the record is created.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Email: </strong> Email address is used to complete new User
          registration process. Each user must have a unique email address,
          since it is used as username to login into the platform. Email cannot
          be changed once the User record is created.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Phone: </strong> Phone number for record keeping.
        </Typography>
      </li>
      <li>
        <Typography>
          <strong>Access: </strong> Invited users join as Dispatch, which allows
          them to claim loads and manage the other users in their own carrier
          account. Drivers do not sign in to the portal, so there is nothing to
          choose here.
        </Typography>
      </li>
    </ul>
  </>
);

export const CarrierUserEditHelp = () => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="subtitle1">
        Carrier info is locked. Only they user can edit their Profile info such
        as name and phone.
      </Typography>
      <ul>
        <li>
          <Typography>
            <strong>Email: </strong> Email address is used to complete new User
            registration process. Each user must have a unique email address,
            since it is used as username to login into the platform. Email
            cannot be changed once the User record is created.
          </Typography>
        </li>
        <li>
          <Typography>
            <strong>Block Access: </strong> Suspends the user's access to this
            transload without deleting their record.
          </Typography>
        </li>
        <li>
          <Typography>
            <TransferIcon className={classes.icon} />
            <strong> MOVE: </strong>
            Puts a driver on file with a different carrier — for a driver who
            enrolled themselves under the wrong company, or who has changed
            employer. Their driver ID, gate photo, documents and notes move with
            them; check-ins already recorded keep the carrier they were made
            under. Save or undo your changes first, since the move is written
            straight away.
          </Typography>
        </li>
        <li>
          <Typography>
            <DeleteIcon className={classes.icon} />
            <strong> DELETE: </strong>
            Removes user's access to the selected Account's data. For a
            driver it also offers erasure, which deletes their personal data
            everywhere instead of only here: identity, enrollment, license
            details, contact details and every carrier membership. Check-ins
            already recorded stay on file under the carrier they were made
            for, without the driver's name. Erasure is unavailable for a
            driver other transloads also have on file — removing them from
            yours is then the only exit.
          </Typography>
        </li>
      </ul>
    </>
  );
};
